import { ProvidePersonalPage } from '@ppay/client'
import React from 'react'

import { Form } from './Form'

export const Page = () => {
  return <ProvidePersonalPage formComponent={Form} />
}
